import axios from 'axios';
import { serviceUrl } from '../../App';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getPlan = (event_id?: any) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + event_id ? `plan?where=` + event_id : ''
  );
};
export const getOrderByPlan = (cond: string, timezoneOffset: number) => {
  const url =
      GetBackendUrlForGlobalFunctions() +
      `order/${timezoneOffset}`;

  return axios.post(url, {
    where: cond,
  });
};
export const getOrderByMergedPlan = (cond: string) => {
  var query =
    GetBackendUrlForGlobalFunctions() +
    `order/order-merge-by-planned-order?where=` +
    cond;
  return axios.get(query);
};
export const AddPlan = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `plan/create`, obj, {
    headers,
  });
};

export const EditPlan = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `plan/update`, obj, {
    headers,
  });
};

export const DeletePlan = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `plan/delete`, obj, {
    headers,
  });
};
export const AddPlanOrder = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `plan/plan-order-create`,
    obj,
    { headers }
  );
};
export const EditPlanOrder = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `plan/plan-order-update`,
    obj,
    { headers }
  );
};
export const DeletePlanOrder = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `plan/plan-order-delete`,
    obj,
    { headers }
  );
};
